/**
 * Константы для использования во всем проекте.
 */

/**
 * Доступные режимы работы с HTTP/HTTPS.
 *
 * - http - всё работает по http
 * - https - всё работает по https
 * - composite - основной интерфейс и обращения к флюсоникам должны работать по http, API по HTTPS. (deprecated!)
 *
 * Актуальный режим на клиентском приложении настраивается в хранилище состояния при получении контекстной информации.
 *
 * Замечание по протоколам. В идеале всё (стр. авторизации, API, получение видео с флюсов) должно работать либо по http либо по https
 * без вариантов смешивания контента.
 * Протокол страницы авторизации должен совпадать с протоколом по которому будет работать API,
 * чтобы избежать получения cookies и их использования по разным протоколам,
 * так Firefox запрещает использовать куки полученные по одному протоколу на одном домене для запросов с другим протоколом.
 * Если index.html был открыт по https, то браузеры запрещают подгружать видео по http - смешанный контент.
 * Если index.html был открыт по одному протоколу, то браузеры не отправляют куки при обращении на API по другому протоколу,
 * см. Access-Control-Allow-Origin.
 */
export const HTTP_MODE = Object.freeze({
  http: "http",
  https: "https",
  composite: "composite",
});

/**
 * Форматы для скачивания видео.
 */
export const DOWNLOADS_TYPES = Object.freeze({
  MP4: "MP4",
  TS: "TS",
});
